document.addEventListener('turbolinks:load', function () {
  // 開発環境での開発スピードを上げるため青木の開発環境でのみ
  // manage/app/javascript/packs内の本jsファイルを走らせない
  if ((location.href.includes('dev-manage-ssl.platta.jp') || location.href.includes('http://18.177.103.115:3004')) && !location.href.includes('?dev27aoki')) {
    console.log('dev環境 public.jsを使用');
    return;
  }
  //!!!!!!!!!!!!!!!!!!!!!!!!!!! pack内の.jsファイルに上記を適用 !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  const ERROR_MSG = 'エラー！ 処理を完了できませんでした\n時間おいて再度実行しても、このエラーが修正されない場合は\nお手数ですがサポートチームにお問い合わせください';
  const MAIL_PATTERN = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
  const PASSWORD_PATTERN = /([0-9].*[a-zA-Z]|[a-zA-Z].*[0-9])/;
  const DOMAIN = $('#pl_domain').val();
  let current_url = location.href;

  const left_menu_el = $('.left_menu');
  // ログイン画面やアドミン画面で非表示させないようにする
  if (left_menu_el.length > 0) {
    const sidebar_hide_mark_el = $('.application_hide_sidebar');
    const sidebar_hide_mark_el_icon = $('.application_hide_sidebar__icon');
    const div_main_el = $('div.main');

    // サイドバーを開く、閉じるを実装
    // 上記だとmouse移動時に常にイベントが走って負荷が重いため下記に変更した
    let throttled = _.throttle(function (e) {
      if (e.pageX < 800) {
        sidebar_hide_mark_el.fadeIn(300);
      } else {
        sidebar_hide_mark_el.fadeOut(300);
      }
    }, 200);

    $(document).on('mousemove', throttled);

    $('.application_hide_sidebar, #menu_display')
      // .off('click')
      // .on('click', function () {
      //   if (left_menu_el.is(':visible')) {
      //     left_menu_el.hide(500);
      //     div_main_el.animate({ 'padding-left': '0px' }, 500);
      //     sidebar_hide_mark_el.animate({ left: '1%' });
      //     sidebar_hide_mark_el_icon.removeClass('fa-angles-left');
      //     sidebar_hide_mark_el_icon.addClass('fa-angles-right');
      //   } else {
      //     left_menu_el.show(500);
      //     div_main_el.animate({ 'padding-left': '216px' }, 500);
      //     sidebar_hide_mark_el.animate({ left: '200px' });
      //     sidebar_hide_mark_el_icon.addClass('fa-angles-left');
      //     sidebar_hide_mark_el_icon.removeClass('fa-angles-right');
      //   }
      // });
  }

  // すべての投稿一覧、設定/upload関連, 分析 application.html.erb click時アコーディオン表示
  $('#to_all_post_type_display, #to_all_master_upload, #to_all_setting_upload, #to_all_analytics, #to_all_groups, #to_all_accounts, #to_insight, #to_hashframe').on('click', function (event) {
    let ulElement = $(`#${$(this).attr("id")}_ul`);

    if (ulElement.is(':visible')) {
      // 非表示
      ulElement.slideUp();
    } else {
      // 表示
      ulElement.slideDown();
    }

    event.stopPropagation();
  });
});
